/* global KNB */
import tip from './tip';

export default class ToastUtil {
    static show (msg, duration) {
        if (KNB && KNB.toast) {
            KNB.use('toast', {
                duration: duration || 0,
                content: msg,
                fail () {
                    tip.info(msg, duration);
                }
            });
        } else {
            tip.info(msg, duration);
        }
    }
}